<template>
    <v-container fluid>
        <div v-if="!receiptLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Modify Good Receipt #{{data.code}}</h4>
                    <p class="text-subtitle-1">Good Receipt Edit Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <GoodReceiptForm class="ma-2" v-model="data" ref="form"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn class="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed @click="handleDiscard">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PAlert from "./../../components/common/PAlert.vue"
import { mapActions, mapGetters } from "vuex";
import GoodReceiptForm from './../../components/purchase/GoodReceiptForm.vue';
export default {
    name: "GoodReceiptEditView",
    components: {
        GoodReceiptForm,
        PAlert,
    },
    data() {
        return {
            id: null,
            loading: false,
            receiptLoading: false,
            data: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are You Sure",
                callback: null
            },
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/goodReceipt/findByID",
            pushItem: "purchase/item/push",
            pushWarehouse: "purchase/warehouse/push",
            snackbar: "ui/snackbar/show",
            update: "purchase/goodReceipt/update",
            delete: "purchase/goodReceipt/delete",
        }),
        handleSave() {
            this.alert = {...this.alert,content: "Are You Sure You Want To Save", value: true, callback: this.save }
        },
        handleNewLine() {
            this.$refs.form.addLine()
        },
        handleDiscard() {
            this.alert = {...this.alert,content: "Are You Sure You Want To Discard", value: true, callback: this.discard }
        },
        fetchGoodReceipt() {
            this.receiptLoading = true
            this.findByID(this.id).then(response => {
                this.data = this.prepareReceiptForm(response.data);
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => this.receiptLoading = false);
        },
        prepareReceiptForm(receipt) {
            this.pushWarehouse(receipt.warehouse);
            return {
                    ...receipt,
                    warehouse_id : receipt.warehouse.id,
                    purchase_order_code : receipt.purchase_order.code,
                    purchase_order_id : receipt.purchase_order.id,
                    lines: receipt.lines.map(line => {
                        this.pushItem(line.item)
                        return {
                            ...line,
                            item_id : line.item.id,
                            quantity : line.quantity,
                            measure_unit_id : line.measure_unit.id
                        }
                    })
                }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.update(this.data).then(response => {
                this.snackbar({text: "Goods Receipt Updated", color: "success"})
                this.$router.push({ name: "GoodReceiptDisplay", params: { id: response.data.id}});
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => this.loading = false);
        },
        discard() {
            this.$router.back();
        }
    },
    mounted(){
        this.id = this.$route.params.id
        this.fetchGoodReceipt()
    },
    beforeRouteUpdate(to, from, next){
        this.id = to.params.id;
        this.fetchGoodReceipt();
        next();
    }
}
</script>

<style>

</style>